import { useEffect, useState } from 'react'
import { ScoopButton, ScoopRadioButton } from '../../../../ui'
import { FilterAndTimeRange } from '../FilterAndTimeRange/FilterAndTimeRange'
import { GroupAnalysisResult } from '../GroupAnalysisResult/GroupAnalysisResult'
import { EVENTS, trackEvent } from '../../../../../events'
import styles from './GroupAnalysis.module.scss'

export const GroupAnalysis = ({
    server,
    filterList,
    selectedInbox,
    mlResults,
    analyze,
    mlConfig,
    setMlConfig,
}) => {
    const [compareToGroup, setCompareToGroup] = useState(false)
    const [groupFiltersOpen, setGroupFiltersOpen] = useState(false)
    const [groupTwoFiltersOpen, setGroupTwoFiltersOpen] = useState(false)
    const [groupDialogSelectedFilters, setGroupDialogSelectedFilters] = useState([])
    const [groupTwoDialogSelectedFilters, setGroupTwoDialogSelectedFilters] = useState([])

    useEffect(() => {
        if (mlConfig) {
            setCompareToGroup(false)
            if (mlConfig.groupOneFilters) {
                setGroupDialogSelectedFilters(mlConfig.groupOneFilters)
            } else {
                setGroupDialogSelectedFilters([])
            }
            if (mlConfig.groupTwoFilters) {
                setGroupTwoDialogSelectedFilters(mlConfig.groupTwoFilters)
                setCompareToGroup(true)
            } else {
                setGroupTwoDialogSelectedFilters([])
            }
        }
    }, mlConfig)

    return (
        <>
            {!mlResults && (
                <div className={styles.container}>
                    <p className={styles.description}>
                        This machine learning analysis will attempt to find rules or patterns that
                        indicate membership in a group. This can help uncover the differences
                        between one group and the overall population, or that group and another
                        group. Scoop allows you to define a group flexibly using one or more saved
                        filters. Those filters will define which subset of your dataset belong to
                        that group. Scoop can then find patterns that distinguish that group.
                    </p>
                    <div className={styles.filterRow}>
                        <p className={styles.filterLabel}>Pick filters that define your group:</p>
                        <ScoopButton
                            size="sm"
                            className={styles.selectFiltersButton}
                            onClick={() => {
                                setGroupFiltersOpen(true)
                            }}
                        >
                            Select Filters
                        </ScoopButton>
                    </div>
                    <div className={styles.compareRow}>
                        <p className={styles.compareLabel}>Compare group to:</p>
                        <div className={styles.radioGroup}>
                            <ScoopRadioButton
                                label="Those not in group"
                                name="radio-buttons-group"
                                value="false"
                                checked={!compareToGroup}
                                onChange={(e) => {
                                    setCompareToGroup(e.target.value === 'true')
                                }}
                            />
                            <ScoopRadioButton
                                label="Another group"
                                name="radio-buttons-group"
                                value="true"
                                checked={compareToGroup}
                                onChange={(e) => {
                                    setCompareToGroup(e.target.value === 'true')
                                }}
                            />
                        </div>
                        {compareToGroup && (
                            <ScoopButton
                                size="sm"
                                className={styles.comparisonButton}
                                onClick={() => {
                                    setGroupTwoFiltersOpen(true)
                                }}
                            >
                                Select Comparison Group Filters
                            </ScoopButton>
                        )}
                    </div>
                </div>
            )}
            <GroupAnalysisResult mlResults={mlResults} />
            {!mlResults && (
                <ScoopButton
                    onClick={() => {
                        if (mlConfig.groupOneFilters) {
                        }
                        let jsonBody = {
                            action: 'comparePopulations',
                            groupOneFilters: mlConfig.groupOneFilters,
                        }
                        if (compareToGroup && mlConfig.groupTwoFilters) {
                            jsonBody.groupTwoFilters = mlConfig.groupTwoFilters
                        }
                        trackEvent(EVENTS.DATA_SCIENCE.EXPLAIN_GROUP, { compareToGroup })
                        analyze(jsonBody)
                    }}
                    disabled={!mlConfig?.groupOneFilters || mlConfig?.groupOneFilters.length === 0}
                >
                    Analyze
                </ScoopButton>
            )}
            <FilterAndTimeRange
                server={server}
                title={`Select filters that will define your group`}
                pickFiltersDialogOpen={groupFiltersOpen}
                setPickFiltersDialogOpen={setGroupFiltersOpen}
                dialogSelectedFilters={groupDialogSelectedFilters}
                selectedInbox={selectedInbox}
                setDialogSelectedFilters={setGroupDialogSelectedFilters}
                setSelectedFilters={(newFilters) => {
                    if (newFilters && newFilters.length > 0) {
                        mlConfig.groupOneFilters = newFilters
                    } else {
                        mlConfig.groupOneFilters = null
                    }
                    setMlConfig({ ...mlConfig })
                }}
                filterList={filterList}
            />
            <FilterAndTimeRange
                server={server}
                title={`Select filters that will define your comparison group`}
                pickFiltersDialogOpen={groupTwoFiltersOpen}
                setPickFiltersDialogOpen={setGroupTwoFiltersOpen}
                dialogSelectedFilters={groupTwoDialogSelectedFilters}
                selectedInbox={selectedInbox}
                setDialogSelectedFilters={setGroupTwoDialogSelectedFilters}
                setSelectedFilters={(newFilters) => {
                    if (newFilters && newFilters.length > 0) {
                        mlConfig.groupTwoFilters = newFilters
                    } else {
                        mlConfig.groupTwoFilters = null
                    }
                    setMlConfig({ ...mlConfig })
                }}
                filterList={filterList}
            />
        </>
    )
}
